import { customSetupAxios } from '@supplement-bacon/react-toolkit/utils'
import { getAuth } from '@utils/AuthLocalStorageHelper'
import axios from 'axios'
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { Outlet, useNavigate } from 'react-router-dom'
import { AuthInit, AuthProvider } from './utils/auth/Auth'

function App() {
  const navigate = useNavigate()

  /**
   * Inject interceptors for axios.
   *
   * @see https://github.com/axios/axios#interceptors
   */
  customSetupAxios(
    axios,
    () => {
      const auth = getAuth()
      return Promise.resolve(
        auth !== undefined && auth.access_token ? auth.access_token : ''
      )
    },
    undefined,
    'fr',
    () => {
      navigate('/auth/login')
    }
  )

  dayjs.locale('fr')
  dayjs.extend(relativeTime)
  dayjs.extend(utc)
  dayjs.extend(timezone)
  dayjs.tz.setDefault('Europe/Paris')

  return (
    <AuthProvider>
      <AuthInit>
        <Outlet />
      </AuthInit>
    </AuthProvider>
  )
}

export default App
